import { FC } from 'react';
import { merge } from '../../utils/utility';
import { ImagePreloader } from '../image/ImagePreloader';

interface Props {
  url: string;
  className?: string;
}

export const MiniPicture: FC<Props> = ({ url, className }) => {
  return (
    <div className="rounded-full overflow-hidden w-16 h-16 flex items-center justify-center">
    <div
      className={merge(className, 'w-28 h-28 bg-cover bg-center')}
      style={{ backgroundImage: `url(${url})` }}
    >
      <ImagePreloader url={url} />
    </div>
    </div>

  );
};
